var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232 233",
    style: {
      enableBackground: "new 0 0 232 233"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.2968,
    y1: 229.5674,
    x2: 139.2728,
    y2: -3.0446,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#780000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C1121F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,232.7c34,0,64.6-14.7,85.8-38l-5.6-6.2c-7-7.7-18.9-8.4-26.7-1.5l-12,10.7 c-16.4,14.5-41.3,13.6-56.6-2.1l-7.5-7.7c-7.2-7.4-19.1-7.7-26.6-0.6L44,208C63.7,223.5,88.5,232.7,115.4,232.7z M211.9,173.7l2.7,3 c10.7-17.6,16.8-38.3,16.8-60.4c0-26.8-9-51.5-24.2-71.2c-2.8,0.7-5.5,2.1-7.9,4.2l-12,10.7c-16.4,14.5-41.3,13.6-56.6-2.1l-7.5-7.7 c-7.2-7.4-19.1-7.7-26.6-0.6l-31,29.2l-15.1-16l31-29.2c16.3-15.3,41.9-14.8,57.5,1.3l7.5,7.7c7.1,7.3,18.6,7.7,26.2,1l12-10.7 c2-1.8,4.2-3.3,6.4-4.7C170.8,10.6,144.4,0,115.4,0C57.2,0,9,43,0.7,99c15.9-9.2,36.5-6.8,49.8,6.9l8.7,8.9c6.8,7,17.7,7.7,25.3,1.7 l25.8-20.2c15.5-12.1,37.4-11.6,52.3,1.4l35.2,30.7L183.3,145l-35.2-30.7c-6.9-6-17-6.3-24.2-0.6l-25.8,20.2 c-16.5,12.9-40,11.3-54.7-3.7l-8.7-8.9c-7.2-7.4-19.1-7.7-26.6-0.6L0,128.4c2.5,24.6,12.7,46.9,28,64.5l23-21.6 c16.3-15.3,41.9-14.8,57.5,1.3l7.5,7.7c7.1,7.3,18.6,7.7,26.2,1l12-10.7C171.1,155.6,196.8,157,211.9,173.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeiIcon);
export default __webpack_public_path__ + "static/media/sei_icon.1b34cf5a6fc01b964116ae2781e13b05.svg";
export { ForwardRef as ReactComponent };